import { authRequest } from "src/engine/modules/authRequest"

// Спека https://next.stoplight.io/infotech-group/planner/version%2F1.0/main.oas2.yml?view=%2Fplans%2Flockplans
export const lockPlan = planUuids =>
  authRequest({
    url: `/plans/lock`,
    method: `post`,
    data: planUuids,
  })

export const unlockPlan = planUuids =>
  authRequest({
    url: `/plans/lock`,
    method: `delete`,
    data: planUuids,
  })
